import API, { createEmptyAxiosInstance } from 'utils/api';
import { onError } from 'utils/handlers';
import { titleize } from 'utils/normalizers';

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const BLANKAPI = createEmptyAxiosInstance();

export const consultaConTask = async (values, url, usePost, config) => {
  try {
    const _url = url.at(-1) !== '/' ? `${url}/` : url;
    let response = { data: null };
    const _API = config ? BLANKAPI : API;
    if (usePost) {
      response = await _API.post(_url, values, config);
    } else {
      response = await _API.get(_url, { ...config, params: values });
    }
    return [response.data, undefined];
  } catch (err) {
    const isTimeoutError = /timeout/i.test(err.message);
    if (isTimeoutError) {
      return consultaConTask({ ...values, timeout: true }, url);
    }
    onError(err);
    return [undefined, err?.response?.data];
  }
};

const DEFAULT_POLL_INTERVAL = 3000;
const DEFAULT_POLL_TIMEOUT = 15 * 60 * 1000;

export const pollEstadoJob = async (url, {
  interval = DEFAULT_POLL_INTERVAL,
  timeout = DEFAULT_POLL_TIMEOUT,
  esTerminal = (data) => data?.estado === 'completado' || data?.estado === 'error',
} = {}) => {
  const startedAt = Date.now();
  // eslint-disable-next-line no-constant-condition
  while (true) {
    // eslint-disable-next-line no-await-in-loop
    const [data, error] = await consultaConTask(undefined, url, false);
    if (!data) return [undefined, error];
    if (esTerminal(data)) return [data, undefined];
    if (Date.now() - startedAt >= timeout) return [undefined, { timeout: true }];
    // eslint-disable-next-line no-await-in-loop
    await wait(interval);
  }
};

export const getConsultaTask = async (
  values,
  url,
  defaultMessage,
  valueKey,
  defaultValue = [],
  usePost = false,
  config,
  setLoadingMessage = () => null,
) => {
  const [data, error] = await consultaConTask(values, url, usePost, config);

  if (data?.detail || data?.status) {
    setLoadingMessage(titleize(data.detail || data.status));
    await wait(5000);
    return getConsultaTask(
      values,
      url,
      defaultMessage,
      valueKey,
      defaultValue,
      usePost,
      config,
      setLoadingMessage,
    );
  }
  if (data && ((valueKey && data?.[valueKey]) || !valueKey)) {
    setLoadingMessage();
    return [valueKey ? data[valueKey] : data];
  }
  if (defaultMessage) setLoadingMessage(defaultMessage);
  return [defaultValue, error];
};
